import { render, staticRenderFns } from "./external-link.vue?vue&type=template&id=d2cc8eb0&scoped=true&"
import script from "./external-link.vue?vue&type=script&lang=js&"
export * from "./external-link.vue?vue&type=script&lang=js&"
import style0 from "./external-link.vue?vue&type=style&index=0&id=d2cc8eb0&prod&lang=scss&scoped=true&"
import style1 from "./external-link.vue?vue&type=style&index=1&id=d2cc8eb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cc8eb0",
  null
  
)

export default component.exports